import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, computed } from '@angular/core';
import { LayoutService } from '../../services/LayoutService';
import { RegistryService } from '../../services/RegistryService';
// @ts-ignore
import './billing-settings-component/billing-settings-page.js';

@Component({
  selector: 'app-billing',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  template: `
    <billing-settings-page
      [attr.theme]="layout.theme()"
      [activePlans]="activePlans()"
      (paymentmethodrequest)="openPaymentPage()"
      (planchange)="onPlanChange($event)">
    </billing-settings-page>
  `,
  styles: [`
    billing-settings-page {
      display: block;
      min-height: 100vh;
    }
  `]
})
export class BillingComponent {
  public layout = inject(LayoutService);
  private registry = inject(RegistryService);

  public activePlans = computed(() => {
    const services = this.registry.services();
    const plans: string[] = [];
    if (services.some(s => s.name === 'lite_schedule')) {
      plans.push('lite_schedule');
    }
    if (services.some(s => s.name === 'tasks')) {
      plans.push('tasks');
    }
    return plans;
  });

  openPaymentPage() {
    const url = 'https://pay.grow.link/MTAwODUy~2c8c92c883ee2f187e83e1755ed6e0fd-MzQ0ODExNA';
    const windowFeatures = 'noopener,noreferrer,width=1000,height=800,scrollbars=yes,resizable=yes';
    window.open(url, '_blank', windowFeatures);
  }

  onPlanChange(event: Event) {
    const customEvent = event as CustomEvent;
    console.log('Billing plans changed:', customEvent.detail);
  }
}

